// Config compartida de TODOS los JoditEditor de esta app (ago 2026).
//
// - Pegar entra SIEMPRE como HTML limpio ('insert_clear_html'): conserva la
//   estructura (p, listas, tablas) y elimina los estilos inline de Word/Excel
//   — la causa del markup inflado detectado en prod (98% del peso de las
//   descripciones era markup, no texto).
// - Sin botón de código fuente: el HTML a mano igual se sanitiza en el server
//   (allowlist HtmlSanitizer del paquete kangoru/i18n — LA capa de seguridad;
//   esto es solo UX), pero quitarlo evita HTML basura de usuarios legítimos.
//
// Espejo en apps/sellers y theme-001 (Jodit v3 aquí, v4 en theme-001 — estas
// claves existen en ambas). Cambios: aplicar en las 3 copias.
export const joditConfig = {
	readonly: false,
	askBeforePasteHTML: false,
	askBeforePasteFromWord: false,
	defaultActionOnPaste: 'insert_clear_html',
	defaultActionOnPasteFromWord: 'insert_clear_html',
	removeButtons: ['source'],
};
